import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_ENDPOINTS } from '../config';
import { auth } from '../firebase/firebase'; // Import the auth instance
import { signInWithCustomToken } from 'firebase/auth';

const LoginPage = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [passwordErrorMessage, setPasswordErrorMessage] = useState('');

    useEffect(() => {
        if (localStorage.getItem('token')) {
            navigate('/division');
        }

        let timeout;
        if (passwordErrorMessage) {
            timeout = setTimeout(() => setPasswordErrorMessage(''), 3000);
        }
        return () => clearTimeout(timeout);
    }, [passwordErrorMessage]);

    const handleSubmit = async (event) => {
        event.preventDefault();
        try {
            const data = {
                mail: email,
                password: password
            };
            const response = await fetch(API_ENDPOINTS.loginUser, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            });

            if (response.ok) {
                const receivedData = await response.json();
                localStorage.setItem('token', receivedData.token);

                try {
                    // Best-effort Firebase auth; backend token is already valid for app routes
                    const userCredential = await signInWithCustomToken(auth, receivedData.token);
                    const idToken = await userCredential.user.getIdToken();
                    localStorage.setItem('idToken', idToken);
                } catch (authError) {
                    console.error('Firebase custom-token sign-in failed:', authError);
                    localStorage.removeItem('idToken');
                }

                navigate('/division');
            } else {
                setPasswordErrorMessage('Wrong password or email!');
            }
        } catch (error) {
            console.error('Login request failed:', error);
        }
    }

    return (
        <div className="flex items-center justify-center h-screen bg-gray-100">
            <div className="flex flex-col items-center justify-center gap-4 p-6 m-3 bg-white shadow-md rounded-lg w-full max-w-xs">
                <img
                    className="h-8 w-auto mb-4 cursor-pointer"
                    src="https://static.wixstatic.com/media/9d90f3_e5e08befbf554451a60099a1e5907fbc~mv2.png"
                    alt="CUREosity"
                />
                <h2 className="text-lg font-semibold">Web Access Cloud</h2>
                <form onSubmit={handleSubmit}>
                    <label htmlFor="email">Email</label>
                    <input
                        id="email"
                        autoComplete="username"
                        className="input bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                        placeholder="Email"
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                    <label htmlFor="password">Password</label>
                    <input
                        id="password"
                        autoComplete="current-password"
                        className="input bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                        type="password"
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                    <button
                        type="submit"
                        className="mt-2 bg-green-700 text-white px-4 py-2 rounded hover:bg-green-800 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-opacity-50"
                    >
                        Login
                    </button>
                </form>
                {passwordErrorMessage && <h2>Wrong password or email!</h2>}
            </div>
        </div>
    );
}

export default LoginPage;
